import React from 'react';
import { Translate } from 'react-localize-redux';
import Modal from '../../../components/general/modal';
import { IAgendasConfigParams } from '../../../constants/types';
import { resolveAppointmentPhone } from '../../../utils/appointmentPrefill';
import PatientAppointmentInfo from '../Outpatients/PatientAppointmentInfo';

interface ScheduleAppointmentModalProps {
    open: boolean;
    onClose: () => void;
    uuidPatient: string;
    uuidInvestigation: string;
    outpatientsInfo: IAgendasConfigParams;
    patientPhone?: string | null;
}

export function ScheduleAppointmentModal({
    open,
    onClose,
    uuidPatient,
    uuidInvestigation,
    outpatientsInfo,
    patientPhone,
}: ScheduleAppointmentModalProps) {
    const phoneNumber = resolveAppointmentPhone(outpatientsInfo, patientPhone);

    return (
        <Modal
            open={open}
            title={<Translate id="hospital.search_patient.modal.appointment.title" />}
            closeModal={onClose}
        >
            <PatientAppointmentInfo
                uuidInvestigation={uuidInvestigation}
                uuidPatient={uuidPatient}
                outpatientsInfo={outpatientsInfo}
                phoneNumber={phoneNumber}
                resetModal={onClose}
                appointmentMadeCallback={onClose}
            />
        </Modal>
    );
}
